<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.EDIT') }} {{ $t('USERS.ITEM') }}
      </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <user-form
          v-model="form"
          :errors="errors.getAll()"
          :action="action"
          @update-prop="clearErrorByName($event)"
          @removeFile="addToBeRemoved"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" :disabled="!valid" @click="updateUser">
        {{ $t('BUTTON.UPDATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UserForm from '@/modules/users/components/forms/UserForm';
import errors from '@/modules/_global/mixins/errors';
import { mapActions } from 'vuex';
import { EDIT } from '@/modules/_global/mixins/form-editable';
import { onceRequest } from '@/modules/_global/utils/common';
import removeFile from '@/modules/_global/_components/Autouploadfile/mixins/removeFile';
import { cloneDeep } from 'lodash';

export default {
  name: 'EditUser',

  components: {
    UserForm
  },

  mixins: [errors, removeFile],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: true,
      form: {},
      formCopy: {},
      action: EDIT
    };
  },

  watch: {
    id: {
      deep: true,
      immediate: true,
      handler: 'idWatchHandler'
    }
  },

  methods: {
    ...mapActions('user', ['retrieveUser']),
    ...mapActions('person', ['update']),
    idWatchHandler() {
      this.retrieveUser(this.id).then(({ data }) => {
        this.form.user = data.data;
        this.form.person = this.form.user.person;
        this.form.profile = this.form.person.work_profile;

        this.form.user.roles.forEach(item => {
          this.form.role.push(item.id);
        });
        this.form.user.additional_permissions.forEach(item => {
          this.form.additional_permission.push(item.id);
        });
        this.formCopy = cloneDeep(this.form);
      });
    },

    cancel() {
      if (
        this.form.profile.upload_id &&
        this.form.profile.upload_id !== (this.formCopy.profile.upload || {}).id
      ) {
        this.sendDestroyRequest(this.form.profile.upload.id);
      }
      this.$emit('cancel');
    },

    updateUser: onceRequest(function updateUser() {
      if (!this.$refs.form.validate()) {
        return;
      }

      let data = {
        person: this.form.person,
        user: this.form.user,
        work_profile: this.form.profile.profile,
        roles: Object.assign({}, this.form.role),
        additional_permissions: Object.assign(
          {},
          this.form.additional_permission
        )
      };

      return this.update(data)
        .then(({ data }) => {
          this.filterToBeRemovedIds([(this.formCopy.upload || {}).id]);
          this.removeUnnecessaryFiles();
          this.$emit('updated', data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    })
  }
};
</script>

<style scoped></style>
